export enum ProductPathEnum {
  GESTAO_DE_CLIENTES = "clientes",
  BACKOFFICE = "backoffice",
  BARTER = "barter",
}
